module.exports = __webpack_public_path__ + "fonts/icons-zaki.b67710b.eot";